import React from 'react';

interface NotificationsTabProps {
  notifications: any[];
  onItemSelect?: (item: any) => void;
}

const NotificationsTab: React.FC<NotificationsTabProps> = ({ notifications, onItemSelect }) => {
  if (notifications.length === 0) {
    return (
      <div className="text-center py-5">
        <div className="d-flex flex-column align-items-center">
          <i className="ti ti-bell-x fs-48 text-muted mb-3"></i>
          <h5 className="text-muted">No Notifications</h5>
          <p className="text-muted">You're all caught up! No new notifications.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="notification-list">
      {notifications.map((notification) => (
        <div key={notification.id} className="d-flex align-items-start p-3 border-bottom hover-bg-light">
          <div className="me-3">
            <div className="avatar avatar-sm bg-primary-transparent rounded-circle">
              <i className="ti ti-bell fs-16"></i>
            </div>
          </div>
          <div className="flex-grow-1">
            <div className="d-flex align-items-center justify-content-between mb-1">
              <h6 className="mb-0 fw-medium">{notification.subject}</h6>
              <small className="text-muted">{notification.sentDate}</small>
            </div>
            <p className="text-muted mb-2 small">From: {notification.from}</p>
            <div className="d-flex align-items-center justify-content-between">
              <span className={`badge ${notification.priority === 'High' ? 'bg-danger' : notification.priority === 'Medium' ? 'bg-warning' : 'bg-success'}`}>
                {notification.priority}
              </span>
              <div className="d-flex gap-2">
                <button 
                  className="btn btn-sm btn-outline-primary"
                  onClick={() => onItemSelect && onItemSelect(notification)}
                  title="View"
                >
                  <i className="ti ti-eye"></i>
                </button>
                <button 
                  className="btn btn-sm btn-outline-secondary"
                  title="Mark as Read"
                >
                  <i className="ti ti-check"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default NotificationsTab;